import { GlEmptyState } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
export default {
    name: 'ReleasesEmptyState',
    components: {
        GlEmptyState
    },
    inject: {
        documentationPath: {
            default: null
        },
        illustrationPath: {
            default: null
        },
        newReleasePath: {
            default: null
        }
    },
    i18n: {
        emptyStateTitle: s__('Release|Getting started with releases'),
        emptyStateText: s__("Release|Releases are based on Git tags and mark specific points in a project's development history. They can contain information about the type of changes and can also deliver binaries, like compiled versions of your software."),
        releasesDocumentation: s__('Release|Learn more about releases'),
        moreInformation: s__('Release|More information'),
        newRelease: s__('Release|Create a new release')
    }
};
